import { Injectable } from '@angular/core';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class InstockService {
  private apiUrl = '/instocks';
  private apiSpringUrl = '/spring/instocks';

  constructor(private http: HttpService) { }

  get(
    ownerId ?: number,
    itemCd ?: string,
    itemTx ?: string,
    arrivenoCd ?: string,
    instocknoCd ?: string,
    destlocaCd ?: string,
    destlocaTx ?: string,
    beginDate ?: string,
    endDate ?: string,
    stinstockId ?: number
  ): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
    if (itemCd !== null && itemCd !== undefined) {
      url += ('&itemCd=' + encodeURIComponent(itemCd));
    }
    if (itemTx !== null && itemTx !== undefined) {
      url += ('&itemTx=' + encodeURIComponent(itemTx));
    }
    if (arrivenoCd !== null && arrivenoCd !== undefined) {
      url += ('&arrivenoCd=' + encodeURIComponent(arrivenoCd));
    }
    if (instocknoCd !== null && instocknoCd !== undefined) {
      url += ('&instocknoCd=' + encodeURIComponent(instocknoCd));
    }
    if (destlocaCd !== null && destlocaCd !== undefined) {
      url += ('&destlocaCd=' + encodeURIComponent(destlocaCd));
    }
    if (destlocaTx !== null && destlocaTx !== undefined) {
      url += ('&destlocaTx=' + encodeURIComponent(destlocaTx));
    }
    if (beginDate !== null && beginDate !== '' && beginDate !== undefined) {
      url += ('&beginDt=' + encodeURIComponent(beginDate + 'T00:00:00'));
    }
    if (endDate !== null && endDate !== '' && endDate !== undefined) {
      url += ('&endDt=' + encodeURIComponent(endDate + 'T23:59:59'));
    }
    if (stinstockId !== null && stinstockId !== undefined) {
      url += ('&stinstockId=' + stinstockId);
    }

    return this.http.get(url);
  }

  cancel(
    arrivenoCds: string[],
    arriveresultIds: number[],
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/cancel`;
    const jsonInput = {
      arrivenoCdList: arrivenoCds,
      arriveresultIdList: arriveresultIds,
      updprogramCd: updprogramCd
    };
    return this.http.post(url, jsonInput);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/instock/instock.service.ts